// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/thunderstorms.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/thunderstorms/thunderstorms.js';

mount([g0]);
